module.exports = __webpack_public_path__ + "officialStatic/img/n7.11e328b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/n7.jpg
// module id = un0/
// module chunks = 0